import { ShieldOff } from "lucide-react";

import { Alert, AlertDescription } from "@/components/ui/alert";

interface AccessRestrictedProps {
  /**
   * Page-specific description of what the user cannot access.
   * Keep the phrasing consistent, e.g.
   * "You don't have permission to view Integrations. Contact your administrator to request access."
   */
  message: string;
  className?: string;
}

/**
 * Standard "access restricted" state shown in place of a page's content when the
 * current user lacks permission to view or manage it. Rendered as a destructive
 * alert with a ShieldOff icon so the styling is consistent across the product.
 */
export function AccessRestricted({ message, className }: AccessRestrictedProps) {
  return (
    <Alert variant="destructive" showIcon={false} className={className}>
      <ShieldOff className="h-4 w-4 shrink-0 text-[var(--accent-border)]" />
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
}
